module.exports = __webpack_public_path__ + "static/media/Ex1-S5.107691bc.PNG";